import { Button } from 'components/Button/Button';
import { useI18n } from 'i18n/hooks/useI18n';

type Props = {
  saved: boolean;
  onSave: () => Promise<void>;
  onUnsave: () => Promise<void>;
};

export function SaveOrgMenuItem({ saved, onSave, onUnsave }: Props) {
  const { i18n } = useI18n();

  return (
    <Button
      onClick={() => {
        if (saved) void onUnsave();
        else void onSave();
      }}
      data-qa-id={`${saved ? 'unsave' : 'save'}-org`}
      variant="tertiary-grey"
      iconPosition="left"
      icon={{ type: 'normalized', name: 'star-outline' }}
      size="small"
      type="button"
    >
      {saved ? i18n('Unsave Organization') : i18n('Save Organization')}
    </Button>
  );
}
